import HttpEndpoint from "../network/HttpEndpoint";

export class BaseApi {

    protected apiClient: HttpEndpoint;

    constructor() {
        this.apiClient = new HttpEndpoint();
    }
   
}